Mmg.addShortcode('faq', '.sc-faq', (el, model, $, selector, className) => {

    const $this = $(el);

    (function init(){
        addEvents();
    })();

    function addEvents() {
        if (!$this.hasClass(`${className}--accordion`)) {
            return;
        }
        $this.on('click', `${selector}__question`, toggleAnswer);
    }

    function toggleAnswer(event) {
        event.preventDefault();
        $(event.target).parent(`${selector}__question-answer`).toggleClass('open');
    }
});
